import type { PayloadAction} from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '@shared/hooks';
import type { WebSettings } from '@shared/types/common';

const initialState: { settings: WebSettings } = {
	settings: {},
};

const webSettingsSlice = createSlice({
	name: 'common/webSettings',
	initialState: initialState,
	reducers: {
		setWebSettings: (state, action: PayloadAction<WebSettings>) => {
			state.settings = action.payload;
		},
	},
});

export const webSettingsReducer = webSettingsSlice.reducer;
const actions = webSettingsSlice.actions;

const selectWebSettings = (state: RootState) => state.common.webSettings.settings;

export const useWebSettingsModel = () => {
	const dispatch = useAppDispatch();
	const setSettings = (settings: WebSettings) => dispatch(actions.setWebSettings(settings));

	const webSettings = useAppSelector(selectWebSettings);
	return {
		setSettings,
		webSettings,
	};
};
